import { render, staticRenderFns } from "./type-wrapper.vue?vue&type=template&id=32f0933c&scoped=true&"
import script from "./type-wrapper.vue?vue&type=script&lang=js&"
export * from "./type-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./type-wrapper.vue?vue&type=style&index=0&id=32f0933c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f0933c",
  null
  
)

export default component.exports